"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const typesConstants_1 = require("../../constants/typesConstants");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const messageModal_1 = __importDefault(require("../messageModal/messageModal"));
const messageModalConstant_1 = require("../messageModal/messageModalConstant");
const spinner_1 = __importDefault(require("../spinner/spinner"));
const ActionsLoadingComponent = ({ children, actionType, }) => {
    const { loadingStatus, errorMessage, fieldErrors } = useAppSelector_1.default((state) => ({
        loadingStatus: state.actions[actionType].status,
        errorMessage: state.actions[actionType].errorMessage,
        fieldErrors: state.actions[actionType].errors,
    }));
    let content = children;
    const isCustomAction = actionType === typesConstants_1.CUSTOM_ACTION_TYPE;
    const error = fieldErrors && isCustomAction ? fieldErrors.non_field_errors : errorMessage;
    if (loadingStatus === typesConstants_1.PENDING_STATUS) {
        content = react_1.default.createElement(spinner_1.default, null);
    }
    else if (isCustomAction && loadingStatus === typesConstants_1.SUCCEEDED_STATUS) {
        content = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(messageModal_1.default, { message: "Request was successful", type: messageModalConstant_1.SUCCESS_MESSAGE }),
            children));
    }
    else if (loadingStatus === typesConstants_1.FAILED_STATUS) {
        content = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(messageModal_1.default, { message: error, type: messageModalConstant_1.ERROR_MESSAGE }),
            children));
    }
    return content;
};
exports.default = ActionsLoadingComponent;
